module.exports = "/_next/static/images/blankmonitor-line-7abbf9f1e9d56106824a783a6da09b64.svg";